import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { QuestionType } from '@empathy/survey/base';
import { Question } from '@empathy/survey-core';

import { BlockTypeIconConfig } from '../../../models/blocks/block-type-config.constants';
import { QuestionTypeConfig } from '../../../models/question-type-config.constants';

@Component({
  selector: 'empathy-list-variable-item',
  templateUrl: 'list-variable-item.component.html',
  styleUrls: ['./list-variable-item.component.scss', './_list-variable-item-theme.component.scss']
})
export class ListVariableItemComponent {
  @Input() active: boolean;
  @Input() canRemove: boolean;
  @Input() question: Question;

  @Output() activate = new EventEmitter<string>();
  @Output() removePage = new EventEmitter<string>();

  faClose = faClose;

  blockTypeConfig = BlockTypeIconConfig;
  questionType = QuestionType;
  questionTypeConfig = QuestionTypeConfig;
}
